import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";

import DownloadExcel from "../../../../Extra/DownloadExcel";

const MaterialTrainReport = ({ data }) => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [rawData, setRawData] = useState([]);
  const tableRef = useRef();

  const [loading, setLoading] = useState(false);

  const keys = [
    "SECTION",
    "BLOCK SECTION",
    "DIRECTION",
    "DEMAND",
    "GIVEN",
    "AVAIL",
    "BLOCK TYPE",
  ];

  useEffect(() => {
    if (data) {
      const filData = data.filter(
        (item) =>
          item.Block_Type === "BOBY/N U/LDG" ||
          item.Block_Type === "EUR U/L" ||
          item.Block_Type === "M/BOX UNLDG"
      );

      setRawData(filData);
    }
  }, [data]);

  ////////////

  return (
    <div>
      <div className="table-responsive position-relative">
        <table
          ref={tableRef}
          className="table table-bordered table-striped mb-4 papaDiv"
          style={{ fontSize: "12px" }}
        >
          <thead>
            <tr className="table-dark text-center">
              <th rowSpan={2} className="align-middle ">
                Sr No.
              </th>
              <th rowSpan={2} className="align-middle ">
                Block Date
              </th>
              {keys.map((key) => {
                return (
                  <th key={key} className="border-white">
                    {key}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {rawData.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.reportDate?.slice(0, 10) || "-"}</td>
                <td>{item.section || "-"}</td>
                <td>
                  {item.From_Station} - {item.To_Station || "-"}
                </td>
                <td>{item.Direction || "-"}</td>
                <td>{item.Engg_Demand || "-"}</td>
                <td>{item.Granted_Duration || "-"}</td>
                <td>{item.Availed || "-"}</td>
                <td>{item.Block_Type || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {loading && <Loading />}
      </div>
      <div className="m-1">
        {!rawData ? (
          <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
        ) : null}
        <DownloadExcel
          tableRef={tableRef}
          fileName={`Material Train Report `}
        />
      </div>
    </div>
  );
};

export default MaterialTrainReport;
